import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [

        /* ******************
         *  Main Navigation *
         ****************** */

        {
            name: 'home',
            path: '/',
            component: () => import('../components/routes/Home'),
            meta: {
                title: 'Digital.Fitness',
            },
        },
        {
            name: 'framework',
            path: '/framework',
            component: () => import('../components/routes/Framework'),
            meta: {
                title: 'Digital.Framework',
            },
        },
        {
            name: 'check',
            path: '/check',
            component: () => import('../components/routes/Check'),
            children: [
                {
                    name: 'check_new',
                    path: 'new',
                    component: () => import('../components/routes/Check'),
                    meta: {
                        title: 'Digital.Check',
                    },
                },
            ],
        },
        {
            name: 'tools',
            path: '/tools',
            component: () => import('../components/routes/Tools'),
            meta: {
                title: 'Tools & Services – Digital.Solutions',
            },
        },
        {
            name: 'nanodegrees',
            path: '/nanodegrees',
            component: () => import('../components/routes/NanoDegrees'),
            meta: {
                title: 'Nano-Degrees – Digital.Solutions',
            },
        },
        {
            name: 'cockpit',
            path: '/cockpit',
            component: () => import('../components/routes/Cockpit'),
            meta: {
                title: 'Digital.Cockpit',
            },
        },


        /* ******************
         *  Administration  *
         ****************** */


        {
            path: '/admin/assessments',
            component: () => import('../components/routes/admin/Assessments'),
            children: [
                {
                    name: 'create-assessment',
                    path: 'create',
                    component: () => import('../components/routes/admin/assessments/Form'),
                    meta: {
                        title: 'Assessment hinzufügen',
                        roles: ['ROLE_ASSESSMENTS'],
                    },
                },
                {
                    name: 'edit-assessment',
                    path: ':id',
                    component: () => import('../components/routes/admin/assessments/Form'),
                    meta: {
                        title: 'Assessment bearbeiten',
                        roles: ['ROLE_ASSESSMENTS'],
                    },
                },
                {
                    name: 'admin-assessments',
                    path: '',
                    component: () => import('../components/routes/admin/assessments/List'),
                    meta: {
                        title: 'MyAssessments',
                        roles: ['ROLE_ASSESSMENTS'],
                    },
                },
            ],
        },
        {
            path: '/admin/customers',
            component: () => import('../components/routes/admin/Customers'),
            children: [
                {
                    name: 'edit-customer',
                    path: ':id',
                    component: () => import('../components/routes/admin/customers/Form'),
                    meta: {
                        title: 'Kunde bearbeiten',
                        roles: ['ROLE_CUSTOMERS'],
                    },
                },
                {
                    name: 'admin-customers',
                    path: '',
                    component: () => import('../components/routes/admin/customers/List'),
                    meta: {
                        title: 'MyCustomers',
                        roles: ['ROLE_CUSTOMERS'],
                    },
                },
            ],
        },
        {
            path: '/admin/solutions',
            component: () => import('../components/routes/admin/Solutions'),
            children: [
                {
                    name: 'create-solution',
                    path: 'create',
                    component: () => import('../components/routes/admin/solutions/Form'),
                    meta: {
                        title: 'Solution hinzufügen',
                        roles: ['ROLE_SOLUTIONS'],
                    },
                },
                {
                    name: 'edit-solution',
                    path: ':id',
                    component: () => import('../components/routes/admin/solutions/Form'),
                    meta: {
                        title: 'Solution bearbeiten',
                        roles: ['ROLE_SOLUTIONS'],
                    },
                },
                {
                    name: 'admin-solutions',
                    path: '',
                    component: () => import('../components/routes/admin/solutions/List'),
                    meta: {
                        title: 'MySolutions',
                        roles: ['ROLE_SOLUTIONS'],
                    },
                },
            ],
        },
        {
            path: '/admin/users',
            component: () => import('../components/routes/admin/Users'),
            children: [
                {
                    name: 'create-user',
                    path: 'create',
                    component: () => import('../components/routes/admin/users/Form'),
                    meta: {
                        title: 'Benutzer hinzufügen',
                        roles: ['ROLE_ADMIN'],
                    },
                },
                {
                    name: 'edit-user',
                    path: ':id',
                    component: () => import('../components/routes/admin/users/Form'),
                    meta: {
                        title: 'Benutzer bearbeiten',
                        roles: ['ROLE_ADMIN'],
                    },
                    beforeEnter(to, from, next) {
                        if (store.state.user.profile && to.params.id === store.state.user.profile.id) {
                            store.dispatch('notifications/add', {
                                color: 'danger',
                                title: 'Zugriff verweigert!',
                                description: 'Nutzen Sie die Profilfunktion um Ihren eigenen Benutzer zu bearbeiten.',
                            });
                            next({ name: 'admin-users' });
                            return;
                        }

                        next();
                    },
                },
                {
                    name: 'admin-user-password',
                    path: ':id/password',
                    component: () => import('../components/routes/admin/users/Password'),
                    meta: {
                        title: 'Passwort ändern',
                        roles: ['ROLE_ADMIN'],
                    },
                    beforeEnter(to, from, next) {
                        if (store.state.user.profile && to.params.id === store.state.user.profile.id) {
                            store.dispatch('notifications/add', {
                                color: 'danger',
                                title: 'Zugriff verweigert!',
                                description: 'Nutzen Sie die Profilfunktion um Ihren eigenen Benutzer zu bearbeiten.',
                            });
                            next({ name: 'admin-users' });
                            return;
                        }

                        next();
                    },
                },
                {
                    name: 'admin-users',
                    path: '',
                    component: () => import('../components/routes/admin/users/List'),
                    meta: {
                        title: 'Benutzerverwaltung',
                        roles: ['ROLE_ADMIN'],
                    },
                },
            ],
        },


        /* *******************
         *  User Management  *
         ******************* */

        {
            name: 'login',
            path: '/user/login',
            component: () => import('../components/routes/user/Login'),
            meta: {
                title: 'Digital.Fitness Login',
            },
        },
        {
            name: 'user-profile',
            path: '/user/profile',
            component: () => import('../components/routes/user/Profile'),
            meta: {
                title: 'Benutzerprofil',
                roles: ['ROLE_USER'],
            },
        },
        {
            name: 'user-password',
            path: '/user/password',
            component: () => import('../components/routes/user/Password'),
            meta: {
                title: 'Passwort ändern',
                roles: ['ROLE_USER'],
            },
        },


        /* **************
         *  Assessment  *
         **************** */

        {
            path: '/assessment/:id',
            component: () => import('../components/routes/Assessment'),
            children: [
                {
                    name: 'assessment',
                    path: '',
                    component: () => import('../components/routes/assessment/Summary'),
                    meta: {
                        title: 'Digital.Fitness',
                    },
                },
                {
                    name: 'assessment_check',
                    path: 'check',
                    component: () => import('../components/routes/assessment/Check'),
                    meta: {
                        title: 'Digital.Fitness',
                    },
                },
                {
                    name: 'assessment_survey',
                    path: 'assessment',
                    component: () => import('../components/routes/assessment/Survey'),
                    meta: {
                        title: 'Digital.Fitness',
                    },
                },
                {
                    name: 'assessment_report',
                    path: 'report',
                    component: () => import('../components/routes/assessment/Report'),
                    meta: {
                        title: 'Digital.Fitness',
                    },
                },
            ],
        },


        /* *************
         *  Redirects  *
         ************* */

        {
            // Redirect for old e-mails
            path: '/quickcheck/:voucher',
            redirect: (to) => {
                const match = to.params.voucher.match(/^DF-[0-9]{4}-18-([A-Z0-9]{4}-[A-Z0-9]{4})-[A-Z]$/);

                if (match === null) {
                    return `/assessment/${to.params.voucher}/check`;
                }

                return `/assessment/${match[1]}/check`;
            },
        },


        /* *************
         *  Catch All  *
         ************* */

        {
            path: '*',
            redirect: { name: 'home' },
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.meta.roles && (!store.getters['user/isAuthenticated'] || !store.getters['user/hasAnyRoles'](to.meta.roles))) {
        next({
            name: 'login',
            query: { redirect: to.fullPath },
        });
    } else {
        next();
    }
});

router.afterEach(() => {
    store.commit('navigation/closeMobile');
});

export default router;
